// extracted by mini-css-extract-plugin
module.exports = {"container":"scripts_container__RAS8S","title":"scripts_title__0lXDW","buttons":"scripts_buttons__NI_dM"};